import { combineReducers } from "redux";
import { LOGOUT_SUCCESS } from "../actions/types";

import errorReducer from "./errorReducer";
import authReducer from "./authReducer";
import calenderReducer from "./calenderReducer";
import myThriveLinkReducer from "./myThriveLinkReducer";
import seoReducer from "./seoReducer";
import emailSettingsReducer from "./emailSettingsReducer";
import discountReducer from "./discountReducer";
import myProfileInfoReducer from "./myProfileReducer";
import myChangePasswordReducer from "./myChangePasswordReducer";
import emailTemplateReducer from "./emailTemplateReducer";
import smsTemplateReducer from "./smsTemplateReducer";
import eventSettingsReducer from "./eventSettingsReducer";
import specialOfferReducer from "./specialOfferReducer";
import crmReducer from "./crmReducer";
import directoryInformationReducer from "./directoryInformationReducer";
import bookingReducer from "./bookingReducer";
import layoutReducer from "./layoutReducer";
import bookingHistoryReducer from "./bookingHistoryReducer";
import superAdminPromosReducer from "./superAdminPromosReducer";
import myCalendarReducer from "./myCalendarReducer";
import superAdminDashboardReducer from "./superAdminDashboardReducer";
import planManagerReducer from "./planManagerReducer";
import adminDashboardReducer from "./adminDashboardReducer";
import filterReducer from "./filterReducer";
import calendarReducer from "./calendarReducer";
import subscriptionReducer from "./subscriptionReducer";
import notificationReducer from "./notificationReducer";
import systemSettingsReducer from "./systemSettingsReducer";
import featureAccessReducer from "./featureAccessReducer";
import impersonationReducer from "./impersonationReducer";

const appReducer = combineReducers({
  errors: errorReducer,
  auth: authReducer,
  calendar: calenderReducer,
  myThriveLink: myThriveLinkReducer,
  seo: seoReducer,
  emailSettings: emailSettingsReducer,
  discount: discountReducer,
  myProfile: myProfileInfoReducer,
  myChangePassword: myChangePasswordReducer,
  emailTemplate: emailTemplateReducer,
  smsTemplate: smsTemplateReducer,
  eventSettings: eventSettingsReducer,
  specialOffer: specialOfferReducer,
  //payment: paymentReducer,
  crm: crmReducer,
  directoryinformation: directoryInformationReducer,
  booking: bookingReducer,
  layout: layoutReducer,
  bookingHistory: bookingHistoryReducer,
  superadminpromos: superAdminPromosReducer,
  mycalendar: myCalendarReducer,
  superadmindashboard: superAdminDashboardReducer,
  planManager: planManagerReducer,
  adminDashboard: adminDashboardReducer,
  filter: filterReducer,
  calendar: calendarReducer,
  subscription: subscriptionReducer,
  notification: notificationReducer,
  systemSettings: systemSettingsReducer,
  featureAccess: featureAccessReducer,
  impersonation: impersonationReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
